import React from "react";
import "./spotlight.css";
import { Box, Container, Grid, Link } from "@mui/material";

import templeJson from "../../../../config/temple.json";

function Spotlight(props) {
  const { spotlight } = props;
  return (
    <>
      <Box className="py-4">
         <Container>
            <Grid container className="py-4">
               <Grid item xs={12} sm={12} md={12} lg={12} className="text-center">
                <h6 className="section-title text-center text-primary text-uppercase title-tl mb-5">
                  {spotlight?.data?.title}
                </h6>
               </Grid>
               <Grid item xs={12} sm={12} md={8} lg={8}>
                <div
                  dangerouslySetInnerHTML={{
                    __html: spotlight?.data?.description,
                  }}
                />
               </Grid>
               <Grid item xs={12} sm={12} md={4} lg={4}>
               {spotlight?.data?.is_enabled_video === 1 &&
                  spotlight?.data?.video_url && (
                    <Box className="video-bg text-center py-4">
                      <Box className="img-fluid text-center p-5 ratio ratio-16x9">
                        <Link
                          href={spotlight?.data?.video_url}
                          target="_blank"
                          rel="noopener noreferrer"
                          underline="hover"
                        >
                          {spotlight?.data?.video_url}
                        </Link>
                      </Box>
                    </Box>
               )}

                {spotlight?.data?.is_enabled_image === 1 &&
                  spotlight?.data?.image && (
                    <img
                      className="img-fluid mb-4 mb-lg-0 mt-3"
                      src={spotlight?.data?.image}
                      alt=""
                    />
                )}
               </Grid>
            </Grid>
         </Container>
      </Box>
    </>
  );
}
export default Spotlight;
